<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ isEditMode ? "Editar Registro" : "Nuevo Registro" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
    <!-- Días -->
    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Días</mat-label>
      <mat-select
        [(ngModel)]="currentCreateBusinessPartnerOrder.days"
        name="days"
        multiple
        required
      >
        <mat-option *ngFor="let day of daysList" [value]="day.value">{{
          day.day
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Hora de Inicio -->
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Hora de Inicio</mat-label>
      <input
        matInput
        type="time"
        [(ngModel)]="currentCreateBusinessPartnerOrder.hourStart"
        name="hourStart"
        required
      />
    </mat-form-field>

    <!-- Hora de Fin -->
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Hora de Fin</mat-label>
      <input
        matInput
        type="time"
        [(ngModel)]="currentCreateBusinessPartnerOrder.hourEnd"
        name="hourEnd"
        required
      />
    </mat-form-field>

    <!-- <div class="grid grid-cols-3 gap-4 col-span-2"> -->
    <!-- Minutos de Inicio -->
    <!-- <mat-form-field appearance="fill" >
      <mat-label>Minutos de Inicio</mat-label>
      <input
        matInput
        type="number"
        [(ngModel)]="currentCreateBusinessPartnerOrder.minutesStart"
        name="minutesStart"
        required
      />
    </mat-form-field>
 -->
    <!-- Minutos de Fin -->
    <!-- <mat-form-field appearance="fill" >
      <mat-label>Minutos de Fin</mat-label>
      <input
        matInput
        type="number"
        [(ngModel)]="currentCreateBusinessPartnerOrder.minutesEnd"
        name="minutesEnd"
        required
      />
    </mat-form-field> -->

    <!-- Número de Horas para la Entrega -->
    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Horas para Entrega</mat-label>
      <input
        matInput
        type="number"
        [(ngModel)]="currentCreateBusinessPartnerOrder.numberOfHoursToDelivery"
        name="numberOfHoursToDelivery"
        required
        min="0"
      /> 
    </mat-form-field>

  
    <div class="col-span-2 flex items-center">
      <span class="slide">¿Aplica para todas las rutas?</span>
      <mat-slide-toggle
        [(ngModel)]="currentCreateBusinessPartnerOrder.applyToAllSubRoutes"
        name="applyToAllSubRoutes"
        (change)="onToggleApplyToAllRoutes()"
        color="primary"
      >
      </mat-slide-toggle>
    </div>
    <ng-container *ngIf="!currentCreateBusinessPartnerOrder.applyToAllSubRoutes">
    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label for="group-select">Rutas</mat-label>
      <mat-select
        [formControl]="routeMultiCtrl"
        placeholder="Seleccione las rutas"
        [multiple]="true"
        [disabled]="currentCreateBusinessPartnerOrder.applyToAllSubRoutes"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="routeMultiFilterCtrl"
            [placeholderLabel]="'Buscar grupos de ruta...'"
            [noEntriesFoundLabel]="'No se encontraron resultados'"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let route of filteredRoute | async"
          [value]="route._id"
        >
          <span>
            <b *ngIf="getCode(route) as code">
              {{ code }} -
            </b>{{ route.name }}
          </span>

        </mat-option>
      </mat-select>
      </mat-form-field>
    </ng-container>
    <!-- </div> -->
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
    {{ isEditMode ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>
